import Vue from "vue";
import VueMoment from "vue-moment";

const moment = require("moment");
require("moment/locale/" + process.env.VUE_APP_LANG);

Vue.use(VueMoment, {
  moment
});
